export default __webpack_public_path__ + "static/media/sneakerTabActive.6d78d779.png";